module.exports = __webpack_public_path__ + "img/5.bba128f4.png";